/*
  * This is the controller for the cancelling a job match meeting.
 */
class CancelJobMatchMeetingController {
    /*@ngInject*/
    constructor($rootScope, jobMatchService, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.jobMatchService = jobMatchService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //variables
        this.scheduleData = {
            isCompany: true,
            jobMatchId: '',
            note: '',
            externalNote: '',
            emailAddress: '',
            firstName: '',
            lastName: '',
            role: '',
            department: '',
            company: '',
            startDateTime: '',
            endDateTime: ''
        };
        this.itemDisplayLabel = '';
        this.usersListLabel = '';
        this.cancelLabel = '';
        this.chosenMeeting = '';
        this.meetingsList = [];
        this.externalNotesAction = {};
        this.startDate = '';
        this.startTime = '';
        this.endDate = '';
        this.endTime = '';
        //flags
        this.savingFlag = false;
        this.showFormFlag = false;
        this.loadingFlag = false;
        this.cancellableMeetingsExistFlag = false;
        this.isCorporateFlag = this.$rootScope.userDetails.company.companyType == 'Corporation';
        this.isExternalRequisition = !this.isCorporateFlag;
        this.scheduleData.company = this.$rootScope.userDetails.company.companyId;
        switch (this.itemType) {
            case 'phoneScreen':
                this.itemDisplayLabel = 'Phone Screen';
                this.usersListLabel = 'Select Phone Screen';
                this.cancelLabel = 'Cancel Phone Screen';
                this.noCancellableMeetingsLabel = "No 'Scheduled' Phone Screens are available to cancel !";
                break;
            case 'interview':
                this.itemDisplayLabel = 'Interview';
                this.usersListLabel = 'Select Interview';
                this.cancelLabel = 'Cancel Interview';
                this.noCancellableMeetingsLabel = "No 'Scheduled' Interviews are available to cancel !";
                break;
        }
        this._initializeDateAndTimePickers();
        this.getScheduledItems();
    }
    _initializeDateAndTimePickers() {
        $(document).ready(() => {
            let currentDate = new Date();
            $('#jobMatchScheduleStartDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true,
                enableOnReadonly: false
            });
            $('#jobMatchScheduleEndDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true,
                enableOnReadonly: false
            });
            $('#jobMatchScheduleStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '11:00 AM'
            });
            $('#jobMatchScheduleEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '11:30 AM'
            });
        });
    }
    getScheduledItems() {
        this.loadingFlag = true;
        let loggedInUserId = null;
        if (this.itemType == 'phoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.$rootScope.userDetails.company.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.$rootScope.userDetails.company.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
    }
    _getMeetingsList(response) {
        let meetingsList = [];
        let workflowStep = this.itemType == 'phoneScreen' ? 'ps' : 'in';
        angular.forEach(response, (meetingDetails, key) => {
            let meeting = {};
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            meeting.createdByCompanyId = meetingDetails.company;
            meeting.isCreatedByClient = meeting.createdByCompanyId !== null && meeting.createdByCompanyId !== this.scheduleData.company && !this.isCorporateFlag;
            //let currentDateTime = new Date();
            let startDateTime = new Date(meetingDetails.meetingStartTime);
            let endDateTime = new Date(meetingDetails.meetingEndTime);
            switch (meeting.status) {
                case 'SCHEDULED':
                    meeting.statusClass = 'fa fa-calendar meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    this.cancellableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'fas fa-clock meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    this.cancellableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fas fa-hourglass-half meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = false;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = false;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTime = moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + moment(endDateTime).format("hh:mm a )");
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, (meetingUser, k) => {
                let user = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                user.isPoc = meetingUser.isPoc;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                meeting.userList.push(user);
                if (this.isSharedRequisition && !this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                }
                else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            // meeting.label = user.userName + ' - ' + meeting.scheduledTime;
            meetingsList.push(meeting);
        });
        return meetingsList;
    }
    cancelMeeting() {
        if (!this.cancelForm.$invalid) {
            this.savingFlag = true;
            let meetingObject = {
                companyId: this.scheduleData.company,
                note: this.scheduleData.note,
                externalNote: this.scheduleData.externalNote
            };
            this.jobMatchService.cancelMeeting(this.chosenMeeting.id, meetingObject, (data) => {
                this.savingFlag = false;
                if (!_.isUndefined(this.saveCallback)) {
                    this.saveCallback();
                }
            }, (error) => {
                this.savingFlag = false;
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
    }
    meetingChanged() {
        this.showFormFlag = false;
        this.loadingFlag = true;
        this.viewMode = this.chosenMeeting.isCreatedByClient;
        this.jobMatchService.getMeetingDetails(this.chosenMeeting.id, (data) => {
            let participant = data.participants[0];
            this.scheduleData.firstName = participant.firstName;
            this.scheduleData.lastName = participant.lastName;
            this.scheduleData.emailAddress = participant.email;
            this.scheduleData.role = participant.role;
            this.scheduleData.department = participant.department;
            this.scheduleData.note = data.note;
            this.scheduleData.externalNote = data.externalNote;
            if (_.isNull(this.scheduleData.department)) {
                this.scheduleData.department = '-';
            }
            else if (this.scheduleData.department.toString().trim() == '') {
                this.scheduleData.department = '-';
            }
            let startDateTime = new Date(data.startTime);
            let endDateTime = new Date(data.endTime);
            $("#jobMatchScheduleStartDate").datepicker("setDate", startDateTime);
            $("#jobMatchScheduleEndDate").datepicker("setDate", endDateTime);
            $('#jobMatchScheduleStartTime').timepicker("setTime", startDateTime);
            $('#jobMatchScheduleEndTime').timepicker("setTime", endDateTime);
            this.loadingFlag = false;
            this.showFormFlag = true;
        }, (error) => {
            this.loadingFlag = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    onInternalNoteChanged() {
        this.scheduleData.externalNote = this.scheduleData.note;
    }
    onExternalNoteChange(event) {
        this.scheduleData.externalNote = event.externalNote;
    }
    onCopyNoteChange(event) {
        this.copyNote = event.copyNote;
    }
    receiveFormalizedComment(event) {
        this.scheduleData.note = event;
        this.onInternalNoteChanged();
    }
    onVoiceTranscript(transcript) {
        if (this.scheduleData.note) {
            this.scheduleData.note += ' ' + transcript;
        }
        else {
            this.scheduleData.note = transcript;
        }
        this.onInternalNoteChanged();
    }
}
CancelJobMatchMeetingController.$inject = ['$rootScope', 'jobMatchService', 'meetingService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './cancel-job-match-meeting.html;
import * as TEMPLATE from 'raw-loader!./cancel-job-match-meeting.html';
export const CancelJobMatchMeetingComponent = {
    selector: 'cancelJobMatchMeeting',
    component: {
        bindings: {
            jobMatchObject: '<',
            isSharedRequisition: '<',
            saveCallback: '&',
            itemType: '@',
            jobMatchId: '@',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: CancelJobMatchMeetingController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/cancelJobMatchMeeting/cancel-job-match-meeting.html'
    }
};
//# sourceMappingURL=cancel-job-match-meeting.component.js.map